






















import { Component, Vue } from 'vue-property-decorator';

import AppHeader from '@/shared/components/AppHeader.vue';
import LeftMenu from '@/shared/components/LeftMenu.vue';
import Breadcrumb from '@/shared/components/Breadcrumb.vue';

import authService from '@/services/auth-services';
import { APP_CONFIG } from '@/config/app-config';

import AppEvents from '@/event.js';
import { eventBus } from '@/main';

@Component({
  components: {
    AppHeader,
    LeftMenu,
    'bread-crumb': Breadcrumb
  },
})
export default class App extends Vue {
  disableMenuLeft = true;
  disableHeader = true;

  get showMenu() {
    return this.$store.state[APP_CONFIG.stateKey.commonStore].showMenuLeft;
  }

  private beforeCreate() {
    AppEvents.forEach((item) => {
        this.$on(item.name, item.callback);
      });
    window['getApp'] = this;
  }

  private async created() {
    eventBus.$on(APP_CONFIG.eventBusAction.disableMenuLeft, (data) => {
      this.disableMenuLeft = data;
    });

    eventBus.$on(APP_CONFIG.eventBusAction.disableHeader, (data) => {
      this.disableHeader = data;
    });
  }

  private onClickMask() {
    (window['getApp'] as any).$emit('SHOW_HIDE_MENU_LEFT', false);
  }
}
